module.exports = __webpack_public_path__ + "img/logo_moneygram2.919a639c.png";